import { render, staticRenderFns } from "./Choir.vue?vue&type=template&id=bf408c54&"
import script from "./Choir.vue?vue&type=script&lang=ts&"
export * from "./Choir.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports